import { createSlice } from '@reduxjs/toolkit';
import { BASE_END_POINT_JOB } from '../../../config';
import { getLocalStorageAuthentication } from '../../../lib/auth';
import { messageUpdated } from '../app/appSlice';
import { Severity } from '../../../components/Message/Message';

const initialState = {
  submitting: false,
  error: null,
  submitted: false
};

const supportSlice = createSlice({
  name: 'support',
  initialState,
  reducers: {
    submitSupportRequestRequest(state) {
      state.submitting = true;
      state.error = null;
      state.submitted = false;
    },
    submitSupportRequestSuccess(state) {
      state.submitting = false;
      state.submitted = true;
    },
    submitSupportRequestFailure(state, action) {
      state.submitting = false;
      state.error = action.payload.error;
      state.submitted = false;
    },
    clearSupportRequestStatus(state) {
      state.submitting = false;
      state.error = null;
      state.submitted = false;
    }
  }
});

export const {
  submitSupportRequestRequest,
  submitSupportRequestSuccess,
  submitSupportRequestFailure,
  clearSupportRequestStatus
} = supportSlice.actions;

export const supportSubmittingSelector = (state) => state.support.submitting;
export const supportErrorSelector = (state) => state.support.error;
export const supportSubmittedSelector = (state) => state.support.submitted;

export const submitSupportRequest =
  ({ type, subject, description }) =>
  async (dispatch) => {
    dispatch(submitSupportRequestRequest());

    try {
      const localAuth = getLocalStorageAuthentication();
      if (!localAuth || !localAuth.token) {
        throw new Error('Not authenticated');
      }

      const response = await fetch(`${BASE_END_POINT_JOB}/api/v1/support`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localAuth.token}`
        },
        body: JSON.stringify({
          type,
          subject,
          description
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        let errorMsg = `HTTP error! status: ${response.status}`;
        try {
          const errorData = JSON.parse(errorText);
          errorMsg = errorData?.message || errorMsg;
        } catch (e) {
          errorMsg = errorText || errorMsg;
        }
        throw new Error(errorMsg);
      }

      const data = await response.json();
      const apiStatus = data?.status;
      if (
        apiStatus &&
        !['success', 'ok'].includes(apiStatus.toLowerCase())
      ) {
        throw new Error(data?.message || 'Failed to submit support request');
      }

      dispatch(submitSupportRequestSuccess());
      dispatch(
        messageUpdated({
          text: 'Thanks for sharing this — we received it and appreciate the feedback!',
          severity: Severity.SUCCESS
        })
      );

      return { success: true, data: data?.data };
    } catch (error) {
      dispatch(
        submitSupportRequestFailure({
          error: error.message
        })
      );
      dispatch(
        messageUpdated({
          text: error.message || 'Failed to submit support request',
          severity: Severity.ERROR
        })
      );
      return { success: false, error: error.message };
    }
  };

export default supportSlice.reducer;
